import React from "react";

const LOGO_SRC = "/heavenlyai-logo.png";

/**
 * Developer attribution shown at the bottom of every screen.
 * Tweak wording / variant via props.
 *  - variant="footer"  : muted line for use inside the site footer
 *  - variant="hero"    : white text-on-image, for the landing hero
 *  - variant="page"    : centered bar for admin / utility pages
 */
const DevBranding = ({ variant = "footer", className = "" }) => {
    const Inner = (
        <span className="inline-flex items-center gap-2">
            <img
                src={LOGO_SRC}
                alt="HeavenlyAIsolutions logo"
                className="inline-block w-5 h-5 object-contain align-middle"
                loading="lazy"
                draggable="false"
            />
            <span>
                Developed by{" "}
                <a
                    href="https://heavenlyaisolutions.com"
                    target="_blank"
                    rel="noreferrer noopener"
                    className="font-bold underline-offset-2 hover:underline"
                >
                    HeavenlyAIsolutions
                </a>{" "}
                · led by <span className="font-bold">Andres Mocny</span>
            </span>
        </span>
    );

    if (variant === "hero") {
        return (
            <div
                data-testid="dev-branding-hero"
                className={`pointer-events-auto text-[11px] sm:text-xs tracking-wide text-earth-700/80 ${className}`}
            >
                {Inner}
            </div>
        );
    }

    if (variant === "page") {
        return (
            <div
                data-testid="dev-branding-page"
                className={`w-full text-center py-3 text-[11px] tracking-wide text-earth-500 bg-earth-50 border-t border-earth-200 ${className}`}
            >
                {Inner}
            </div>
        );
    }

    // footer variant (default)
    return (
        <div
            data-testid="dev-branding-footer"
            className={`text-[11px] tracking-wide text-earth-500 ${className}`}
        >
            {Inner}
        </div>
    );
};

export default DevBranding;
